import { Renderer } from '@angular/core';
import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { HomePage } from '../../pages/home/home';
import { ObjetoslinPage } from '../../pages/objetoslin/objetoslin';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';

@IonicPage()
@Component({
  selector: 'page-grupos',
  templateUrl: 'grupos.html',
})


export class GruposPage {

  myParam = '';

 diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;

  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",activo1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  grupos;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  empresasKeys;
  values:Array<string> = [];
  trabajadores;
  empresas;
  obras;
  puestos;
  turnos;
 
  constructor(
  	public navParams: NavParams,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider
    ) {                    
            
      this.variables.btatras = true;
      var sum = 0;
      var horas=0;

 
      this.myForm = this.fb.group({id: [''], nombre: ['' ], activo: ['' ] });
      this.myForm1 = this.fb.group({id1: ['', [Validators.required]], nombre1: ['', [Validators.required]], activo1: ['', [Validators.required]] });
   
       this.obtenerobras(this.valo);
       this.obtenerempresas(this.valo);
       this.obtenerturnos(this.valo);
       this.obtenerpuestos(this.valo);
       this.obtenergrupos(this.valo);

  }

salir(){
   this.navCtrl.push(HomePage);
}


  openBasicModal() {
    let myModal = this.modalCtrl.create(ObjetoslinPage);
    myModal.present();
  }

  openModalWithParams(valor) {

  this.myParam ="Seleccione los trabajadores a incluir en el grupo";
  let myModal = this.modalCtrl.create(ObjetoslinPage, {
    'form_padre':'grupos',
    'idgrupo': valor, 
    'caption': this.myParam ,
    'rsempresas': this.empresas,
    'rsobras': this.obras,
    'rspuestos': this.puestos,
    'rsturnos': this.turnos
  }
    );
  myModal.onDidDismiss(data => { 
    // Do things with data coming from modal, for instance : 
    //console.log("valor de data:" + data.trabajadores);

    this.obtenergrupos("654321123456") ;

}); 
  myModal.present();

  }

  openModalWithParams2(valor) {

  this.myParam ="Seleccione los trabajadores a incluir en el grupo";
  let myModal = this.modalCtrl.create(ObjetoslinPage, {
    'filtro': "si",
    'idgrupo': valor, 
    'caption': this.myParam ,
    'rsempresas': this.empresas,
    'rsobras': this.obras,
    'rspuestos': this.puestos,
    'rsturnos': this.turnos
  }
    );
  myModal.onDidDismiss(data => { 
    // Do things with data coming from modal, for instance : 
    //console.log("valor de data:" + data.trabajadores);
    this.obtenergrupos("654321123456") ;

}); 
  myModal.present();

  }

   buscarobjetos(){
     var neutro;
    if (this.formulario2.valor != ""){
      neutro = this.formulario2.valor;
     }else{
      neutro = this.valo;
    }
    //console.log("Vamos a buscar :" + neutro);
    this.funciones.obtienegrupos().then(
          data => {

          this.grupos = data;

          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

  obtenergrupos(filtro){

    this.grupos = [];

    this.funciones.obtienegrupos().then(
          data => {
            
            this.grupos = data;

          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

   editarempresas(index){
    

    this.funciones.editargrupos(this.grupos[index].ID,this.grupos[index].NOMBRE).then(
          data => {
            console.log(data);
            this.grupos = data;
            this.obtenergrupos(this.valo);
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
     
  }

  registro(){

   //console.log(this.formulario.nombre1);

   this.funciones.grabargrupos(this.formulario.nombre1).then(
     data => {
          this.resultado = data;

          this.obtenergrupos(this.valo);

           this.formulario.nombre1="";

        })


  }

   borrar(codigo,nombre){

      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma el borrado del grupo? '  + nombre,
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {

               this.funciones.delgrupos(codigo).then(
                   data => {
                    
                    this.obtenergrupos(this.valo);

                  })           
              }
            }
          ]
        });
        alert.present();
     
  }


ponencampo(campo:string, value:string):void{
      
      switch (campo) {
      
         default:
           // code...
           break;
       }
     
    }
 
 valChange(campo:string, value:string, index:number):void{
      
      switch (campo) {
         case "ID":
           this.grupos[index].ID = value;
           break;
         case "NOMBRE":
           this.grupos[index].NOMBRE = value;
           break;
       
         default:
           // code...
           break;
       }
     
    }



  obtenerpuestos(filtro){

    this.funciones.obtienepuestos(filtro).then(
          data => {

          this.puestos = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

    obtenerempresas(filtro){

    this.funciones.obtieneempresas(filtro).then(
          data => {

          this.empresas = data;
          //console.log(this.empresas);


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

    obtenerobras(filtro){

    this.funciones.obtieneobrasconfiltro(filtro).then(
          data => {

          this.obras = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }


    obtenerturnos(filtro){

    this.funciones.obtieneturnos(filtro).then(
          data => {

          this.turnos = data;


          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }


}




// WEBPACK FOOTER //
// ./src/pages/grupos/grupos.ts